import type { z } from "zod";

/** Readonly is accepted wherever the schema takes an array: zod's input types are mutable, domain values are not. */
type ReadonlyInput<T> = T extends readonly (infer U)[]
  ? readonly ReadonlyInput<U>[]
  : T extends Blob | Date | ((...args: never[]) => unknown)
    ? T
    : T extends object
      ? { readonly [K in keyof T]: ReadonlyInput<T[K]> }
      : T;

/**
 * `schema.parse` takes `unknown`, so a caller that parses at the call site gets
 * the output type for free and the compiler never checks what it sent. This
 * checks the input against the schema's input type first.
 */
export function parseInput<S extends z.ZodTypeAny>(schema: S, input: ReadonlyInput<z.input<S>>): z.output<S> {
  return schema.parse(input);
}
